
import React, {Component} from 'react'
class ErrorComponent extends Component 
{
    render()
    {
        const errorMessage = this.props.error || "Oops, Something went wrong";

        return <div className='error-text d-flex flex-column align-items-center'>
            {errorMessage}
        </div>
    }
}

export default ErrorComponent